/**
 *
 * @param elements {CalendarPublishElement[]}
 * @returns {String}
 */
const calculateOrder = function(elements) {
    return elements.reduce((string, element, index) => {
        const count = _.isUndefined(element.change_count) ? element.changeCount : element.change_count;
        return string + `${element.id}-${count}-${(element.order || (index + 1))}/`;
    }, '');
}

export {calculateOrder};

/**
 *
 * @param layer {CalendarPublishLayer}
 * @param filter {{screen: String, screenGroup: String}}
 * @returns {{limitScreen: String, visible, limitScreengroup, project: String, id, user: String, order}}
 */
export function constructPublishData(layer, filter) {
    return {
        id: layer.id,
        project: Laravel.activeProject,
        user: Laravel.activeUser,
        order: calculateOrder(layer.elements),
        visible: layer.elements,
        limitScreen: filter.screen,
        limitScreengroup: filter.screenGroup
    };
}

export const staticElements = [
    {
        type: 'text',
        eicon: 'text',
        name: Lang.langGet("Text"),
        legacy: false,
    },
    {
        type: 'iframe',
        eicon: 'web',
        name: Lang.langGet("Web"),
        legacy: false,
    },
    {
        type: 'youtube',
        eicon: 'youtube',
        name: Lang.langGet("YouTube"),
        legacy: true,
    },
    {
        type: 'countdown',
        eicon: 'countdown',
        name: Lang.langGet("Countdown"),
        legacy: true,
    },
    {
        type: 'qrcode',
        eicon: 'qrcode',
        name: Lang.langGet("QR Code"),
        legacy: true,
    },
    {
        type: 'emptyrectangle',
        eicon: 'empty-rectangle',
        name: Lang.langGet("Empty Rectangle"),
        legacy: false,
    },
    {
        type: 'clock',
        eicon: 'clock',
        name: Lang.langGet("Clock"),
        legacy: true,
    },
    {
        type: 'day',
        eicon: 'day',
        name: Lang.langGet("Day"),
        legacy: true,
    },
    {
        type: 'weather',
        eicon: 'weather',
        name: Lang.langGet("Weather"),
        legacy: true,
    },
    {
        type: 'layer',
        eicon: 'layer',
        name: Lang.langGet("Layer"),
        legacy: false,
    },
    {
        type: 'esign',
        eicon: 'esign',
        name: Lang.langGet("eSign"),
        legacy: false,
    },
    {
        type: 'rssfeed',
        eicon: 'rss',
        name: Lang.langGet("RSS Feed"),
        legacy: false,
    },
    {
        type: 'streaming',
        eicon: 'streaming',
        name: Lang.langGet("Streaming"),
        legacy: false,
    }
]
